import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Chart } from 'angular-highcharts';
import { PointOptionsObject, SeriesPieOptions } from 'highcharts';
import { take } from 'rxjs/operators';
import { TourAssetRevenue } from '../../../types';

@Component({
  selector: 'lohi-tours-asset-chart',
  templateUrl: './tours-asset-chart.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToursAssetChartComponent implements OnInit, OnChanges {
  @Input() public data: TourAssetRevenue[] | null;
  public chart: Chart;

  constructor() {}

  public ngOnInit(): void {
    this.setupChart();
  }

  public setupChart() {
    this.chart = new Chart({
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'pie',
      },
      credits: {
        enabled: false,
      },
      noData: {
        position: {
          align: 'center',
          verticalAlign: 'middle',
        },
      },
      tooltip: {
        formatter() {
          return (
            `<span class="font-bold" style="color: ${this.point.color}">` +
            this.point.name +
            '</span> ' +
            currencyFormatter.format(this.y)
          );
        },
      },
      title: {
        text: null,
        floating: true,
      },
      legend: {
        enabled: true,
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,
            formatter: formatCurrency,
          },
        },
      },
    });
    this.updateChartData();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    this.updateChartData();
  }

  private updateChartData() {
    this.chart?.ref$.pipe(take(1)).subscribe((chart) => {
      while (chart.series.length) {
        chart.series[0].remove(false, false);
      }
      const series = {
        name: 'Earnings',
        type: 'pie',
        data: this.data.map((value) => {
          return {
            y: value.revenue / 100.0,
            name: value.trailerType,
          } as PointOptionsObject;
        }),
      } as SeriesPieOptions;
      chart.addSeries(series, true, true);
    });
  }
}

function formatCurrency() {
  if (this.y === 0) {
    return '';
  }
  return `<div style="color: ${this.point.color}">${this.point.name}<br> <span style="color: ${
    this.point.color
  }" class="font-bold">${currencyFormatter.format(this.y)}</span></div>`;
}

const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});
